module.exports = __webpack_public_path__ + "static/image-gallery-card-fd42c8547699ac2f14de04961c59341a.png";